import { determineFullTradeData } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import tradeDataStore from "@/store/tradeDataStore";
import React from "react";
import { formatNotionalLeg1Display } from "./notionalLeg1Formatter";
import { getActiveIcebergLegForOP } from "./notionalLeg1Helpers";

const NotionalLeg1 = (params: any) => {
  const fullTradeData = determineFullTradeData(params);

  const currentTradeData = tradeDataStore((state) => state.tradeData);
  const thisTrade = currentTradeData.find(
    (trade) => trade.esid == fullTradeData.esid,
  );

  const formattedValue = formatNotionalLeg1Display(params, thisTrade);
  // ONLY USED FOR OP
  const hasActiveIceberg = getActiveIcebergLegForOP(params, thisTrade) !== null;
  const displayValue =
    formattedValue && hasActiveIceberg ? `${formattedValue} *` : formattedValue;

  return (
    <div
      data-testid="NotionalLeg1CellContainer"
      id="NotionalLeg1CellContainer"
      className="justify-center text-center"
      style={{ width: "100%" }}
    >
      {displayValue}
    </div>
  );
};

export default NotionalLeg1;
